import React, { useMemo } from 'react'
import HypButtonGroup from './HypButtonGroup'
import { Button } from '@material-ui/core'
import { useRegion } from '../../app/hooks'
import { REGION_SIZE_FILTERS } from '../../app/constants/regions'
import useFilterStore from '../../../filters'
import shallow from 'zustand/shallow'

/**
 * Displays the "Show Largest" filter options for the current region,
 * and handles changes via button group.
 */
const SedaFilterSize = props => {
  // pull setters
  const [filters, removeFilter, setFilter] = useFilterStore(
    state => [state.filters, state.removeFilter, state.setFilter],
    shallow
  )

  // pull active region from store
  const [region] = useRegion()

  // size options for current region
  const sizes = [...REGION_SIZE_FILTERS[region]]

  const buttons =
    sizes.map(i => (
      <Button key={i} value={i}>
        {i.toLocaleString()}
      </Button>
    ))

  // extract the active value from active filters
  const active = useMemo(() => {
    const sizeFilter = filters.find(f => f[0] === 'limit')
    if (!sizeFilter) return 'all'
    return sizeFilter[1]
  }, [filters])

  // set the filter (or remove) on changes
  const handleLimitChange = value => {
    if (!value || value === 'all') return removeFilter(['limit'], true)
    return setFilter(['limit', value])
  }

  return (
    <HypButtonGroup
      active={active}
      onChange={handleLimitChange}
      {...props}>
      {[... buttons,
        <Button key={'all'} value={'all'}>
          ALL
        </Button>
      ]}
    </HypButtonGroup>
  )
}

export default SedaFilterSize
